<template>
  <section :class="style.estimate">
    <h2>Ваш расчёт</h2>
    <div
      v-show="
        !['Имя', 'Email', 'Телефон', 'connection'].includes(question) &&
        getAnswerItem(answerItem)
      "
      :class="style.answer"
      v-for="(answerItem, question) in answer as Record<string, any>"
    >
      <span v-text="question" />
      <div v-text="getAnswerItem(answerItem)" />
    </div>
    <div :class="style.result">
      <span>Итого: </span>
      <div :class="style.calculation" ref="calculation" />
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "./estimateComponent.module.scss";
export default defineComponent({
  props: {
    answer: {
      type: Object,
      default: {}
    }
  },
  name: "EstimateComponent",
  data() {
    return {
      style
    };
  },
  mounted() {
    let div = this.$refs.calculation as HTMLElement;
    let count = 0;
    if (div == null) {
      return;
    }
    setInterval(() => {
      let start = -60 + count < 0 ? 0 : -60 + count;
      let center = -30 + count < 0 ? 0 : -30 + count;
      let end = count > 100 ? 100 : count;
      div.style.background = `linear-gradient(90deg, #EEEEEE ${start}%, #F6F6F6 ${center}%, #EEEEEE ${end}%)`;
      count++;
      if (count > 160) {
        count = 0;
      }
    }, 15);
  },
  methods: {
    getAnswerItem(answerItem: string | string[]) {
      if (typeof answerItem === "string") {
        return answerItem;
      }
      if (answerItem.join) {
        return answerItem.join(", ");
      }
      return answerItem;
    }
  }
});
</script>
